
import Vue, { PropType } from 'vue';
import _orderBy from 'lodash/orderBy';
import moment from 'moment';
import Tag from '@/components/Tag/index.vue';
import organizeData, { TableHeader as TableHeaderType } from '@/utils/organizeDataForTable';
import {
  Wrapper, TableContainer, TableHeader, TableRow, Col, ContentIcon,
} from './styles';

export default Vue.extend({
  components: {
    Wrapper,
    TableContainer,
    TableHeader,
    TableRow,
    Col,
    ContentIcon,
    Tag,
  },
  props: {
    headers: {
      type: Array as PropType<TableHeaderType[]>,
      required: true,
    },
    data: {
      type: Array as PropType<any>,
      required: true,
    },
    dataPix: {
      type: Array as PropType<any>,
      required: true,
    },
    orderKey: {
      type: String as PropType<string>,
      default: '',
    },
  },
  data() {
    return {
      values: this.data,
      valuesPix: this.dataPix,
      headersCopy: this.headers as any[],
    };
  },
  computed: {
    datas() {
      const [organizedData, indexedHeaders] = organizeData(this.values, this.headers);
      return { organizedData, indexedHeaders };
    },
    datasPix() {
      const [organizedData, indexedHeaders] = organizeData(this.valuesPix, this.headers);
      return { organizedData, indexedHeaders };
    },
  },
  methods: {
    keys(row: any) {
      return Object.keys(row)
        .map((item) => (item !== '$original' ? { value: row[item], key: item } : null))
        .filter(Boolean);
    },
    goToDetails(row) {
      if (row.$original.type === 'FinancialProdutor') {
        this.$router.push({ name: 'ProdDetails', params: { name: row.$original.name, id: row.$original.id } });
      } else if (row.$original.type === 'Financial') {
        this.$router.push(`/admin/territorioPay/${row.$original.id}/${row.$original.paymentMethods}`);
      } else if (row.$original.type === 'Contastation') {
        this.$router.push(`/admin/territorioInfo/${row.$original.cdTerritory}/${row.$original.name}/${row.$original.document}`);
      } else {
        this.$router.push(`/admin/territorio/${row.$original.cdterritory}`);
      }
    },
    isTag(item: any) {
      return this.datas.indexedHeaders[item]?.tag;
    },
    isHtml(item: any) {
      return this.datas.indexedHeaders[item]?.html;
    },
    orderData(key: string, order: boolean, index: number) {
      this.headersCopy[index].order = order;
      this.mapIndexDifference(key);
      this.orderValues(key, !order ? 'asc' : 'desc');
    },
    orderValues(key: string, orders: 'asc' | 'desc') {
      // if the column value is a date
      if (this.isValidDate(this.data[0][key])) {
        this.values = _orderBy(this.data, (item) => this.formatDateToUnix(item[key]), orders);
        return;
      }

      this.values = _orderBy(this.data, key, orders);
    },
    isValidDate(value: any, dateFormat = 'DD/MM/YYYY') {
      return moment(value, dateFormat, true).isValid();
    },
    formatDateToUnix(date: string, format = 'DD/MM/YYYY') {
      return moment(date, format).valueOf();
    },
    mapIndexDifference(key: string) {
      this.headersCopy = this.headersCopy
        .map((item) => {
          const orderItem = item;

          if (item.key !== key) {
            orderItem.order = false;
            orderItem.selected = false;
            return orderItem;
          }
          orderItem.selected = true;
          return orderItem;
        });
    },
    initOrder() {
      if (this.orderKey) {
        this.headersCopy = this.headersCopy.map((item) => {
          const header = item;

          if (item.key === this.orderKey && item.isOrder) {
            header.selected = true;
            return header;
          }

          header.selected = false;
          return header;
        });

        this.orderValues(this.orderKey, 'asc');
      }
    },
  },
  created() {
    this.initOrder();
  },
});
